<template>
  <v-container fluid class="px-0">
    <v-card outlined class="mb-4" v-if="!loadDefault">
      <v-card-title>
        <v-row no-gutters>
          <v-col cols="4"> {{ $t('Filtras') }}</v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <form @keydown.enter.prevent="submit()">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="4">
              <el-date-picker
                label="Data"
                v-model="mainData['date-search-custom']"
              />
            </v-col>
            <v-col cols="12" md="4">
              <el-text-field
                label="Pavadinimas"
                v-model="mainData['title-search-like']"
                hide-details
                :maxlength="150"
              />
            </v-col>
            <v-col cols="12" md="4">
              <el-text-field
                label="Naudotojas"
                v-model="mainData['created_user_id-search-custom']"
                hide-details
                :maxlength="20"
              />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <el-button
                class="mr-1"
                title="Ieškoti"
                :loading="loading"
                color="primary"
                icon="ieškoti"
                @click.native.stop="beforeSearch()"
              />
              <el-button
                color="secondary"
                icon="išvalyti"
                title="Išvalyti"
                :loading="loading"
                @click.native="clearData()"
              />
            </v-col>
          </v-row>
        </form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CustomCalendarSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    loadDefault: null,
    mainData: {},
    classifiers: [],
    enableVeiksmas: false,
  }),
  computed: {
    ...mapGetters(['searchParams']),
  },
  inject: {
    $validator: '$validator',
  },
  created() {},
  methods: {
    searchData() {
      let searchData = {
        ...this.mainData,
      }

      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
      })

      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {}
      this.searchData()
    },
    submit() {
      this.beforeSearch()
    },
    beforeSearch() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.searchData(true)
        } 
      })
    },
  },
}
</script>
